import React from "react";
import payments from '../images/secure-payment.png';
import trustPay from '../images/trust-pay.png';
import support from '../images/support.png';


function Services() {
    return (
        <section className="section bg-light shadow-md py-4 ">
            <span className='sub-heading text-center d-block mb-4'>Our services</span>
            <div className="container">
                <div className="row">
                    <div className='col-sm-6 col-md-4 service-box'>
                        <div className='flip-box'>
                            <div className='image-box'>
                                <img src={payments} />
                            </div>
                            <div className='text-box'>
                                <h4>100% Secured Payments</h4>
                                <p>
                                    We use industry leading technology while processing your
                                    payment.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className='col-sm-6 col-md-4 service-box'>
                        <div className='flip-box'>
                            <div className='image-box'>
                                <img src={trustPay} />
                            </div>
                            <div className='text-box'>
                                <h4>Trust pay</h4>
                                <p>
                                    100% Payment Protection. Easy Refund Policy
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className='col-sm-6 col-md-4 service-box'>
                        <div className='flip-box'>
                            <div className='image-box'>
                                <img src={support} />
                            </div>
                            <div className='text-box'>
                                <h4>24/7 Support</h4>
                                <p>
                                    Happy to help. Just call our 24/7 customer service whenever needed.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
};

export default Services;